import CurrencyLabel from '@app/shared/components/currency-label/CurrencyLabel';
import HighlightEditableCells from '@app/shared/components/highlight-editable-cells/HighlightEditableCells';
import { ContentHeader } from '@app/shared/layout/content-header/ContentHeader';
import { l } from '@locale/setupI18n';
import ProjectRoutesWrapper from '../../project-routes-wrapper/ProjectRoutesWrapper';
import { RouteConstants } from '../../RouteConstants';
import { AddDealThesisCase } from './AddDealThesisCase';
import { DealThesisForm2 } from './DealThesisNavigation';
import { DealThesisPageNavigation } from './DealThesisPageNavigation';
import { ShowHistoricDataToggle } from '@app/shared/components/show-historic-data/ShowHistoricDataToggle';
import { useAppDispatch, useAppSelector } from '@app/core/hooks/redux-hooks';
import { setDealThesisShowHistoricYears } from '@app/core/store/ui-values-slice';
import { useParams } from 'react-router-dom';

export const DealThesisPage = () => {
  const dispatch = useAppDispatch();
  const { caseId } = useParams();
  const showHistoricDataColumns = useAppSelector(
    (state) => state.uiValues.userSelections.dealThesis.showHistoricDataColumns
  );

  const results = useAppSelector((state) => state.pwerm2Calculation.calculatedInputs);

  const selectedCase = results.cases?.[caseId ?? ''];
  const numberOfResultsHistoricForecastYears = selectedCase
    ? Object.keys(selectedCase.historicDates?.historicForecastYears ?? {}).length
    : 0;

  const numberOfResultsHistoricEvents = selectedCase
    ? Object.keys(results.cases[caseId!].historicDates?.historicEventYears ?? {}).length
    : 0;

  const shouldShowHistoricData =
    numberOfResultsHistoricForecastYears > 0 || numberOfResultsHistoricEvents > 0;

  return (
    <ProjectRoutesWrapper.PageLayout
      key={RouteConstants.DealThesis}
      contentHeader={
        <ContentHeader
          title={l('_DealThesis')}
          actions={<AddDealThesisCase />}
          navigation={<DealThesisPageNavigation />}
          controlOptions={
            <>
              <CurrencyLabel />
              <HighlightEditableCells />
              <ShowHistoricDataToggle
                checked={showHistoricDataColumns}
                onToggle={(checked) => dispatch(setDealThesisShowHistoricYears(checked))}
                shouldShow={shouldShowHistoricData}
              />
            </>
          }
        />
      }
      pageName={RouteConstants.DealThesis}>
      <DealThesisForm2 />
    </ProjectRoutesWrapper.PageLayout>
  );
};
